module.exports = __webpack_public_path__ + "static/media/pozarneuzavery1.7f9115fe.png";